// extracted by mini-css-extract-plugin
export default {"popup":"VTH6oSq69B6jFjuNZWvg"};